module.exports = __webpack_public_path__ + "img/plan-banner.ac68c4d6.jpg";